module.exports = __webpack_public_path__ + "static/media/AddProject.7b8e51f0.svg";